import React from 'react';
import PropTypes from 'prop-types';
import FullTextContentComponent from '@Components/Results/reactions/reaction-details/full-text-content.component';
import externalUrl from '@Utils/ExternalUrl';
import { elsevierExternalUrlStrings } from '@Components/Results/constants';

function CitationsCustomLinkComponent({ citation, fullTextTrackingData, onClick }) {
  if (!citation.fullTextUrl) {
    return null;
  }

  let externalUrlVal = externalUrl(citation.fullTextUrl);
  if (
    window.s &&
    window.s.visitor &&
    externalUrlVal &&
    elsevierExternalUrlStrings.some((substring) => externalUrlVal.includes(substring))
  ) {
    externalUrlVal = window.s.visitor.appendVisitorIDsTo(externalUrlVal);
  }
  return (
    <a
      className="els-btn els-btn-link blue-compact els-btn-xs e2e-full-text"
      href={externalUrlVal}
      tabIndex="0"
      target="_blank"
      rel="noreferrer"
      {...fullTextTrackingData}
      onClick={() => onClick(citation)}>
      <FullTextContentComponent fullTextIconUrl={citation.fullTextIconUrl} />
    </a>
  );
}

CitationsCustomLinkComponent.propTypes = {
  citation: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  // for analytics
  fullTextTrackingData: PropTypes.object.isRequired,
};

export default CitationsCustomLinkComponent;
